import {Component, Input} from '@angular/core';
import {FormControl} from "@angular/forms";
import {AdRPeriod, AdRPeriodType} from '../../../../shared/interfaces/ad-reports';

@Component({
  selector: 'app-smart-alert-configuration-dialog-period',
  templateUrl: './smart-alert-configuration-dialog-period.component.html',
  styleUrls: ['./smart-alert-configuration-dialog-period.component.scss']
})
export class SmartAlertConfigurationDialogPeriodComponent {
  @Input() public control: FormControl;

  public readonly periods: Array<AdRPeriod> = [
    { type: 'last_7_days', name: 'periods.last_7_days' },
    { type: 'last_week', name: 'periods.last_week' },
    { type: 'last_14_days', name: 'periods.last_14_days' },
    { type: 'last_30_days', name: 'periods.last_30_days' },
    { type: 'last_month', name: 'periods.last_month' }
  ];

  constructor() {}

  public periodTextGetter(period: AdRPeriod): string {
    return period.name;
  }

  public periodValueGetter(period: AdRPeriod): AdRPeriodType {
    return period.type;
  }
}
